function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React, { cloneElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { closeModal } from './actions';
import { IconButton } from '../buttons';
import { CrossIcon } from '../icons';
const transition = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Slide, _extends({
  direction: "left",
  ref: ref
}, props)));
const Modal = _ref => {
  let {
    id,
    title,
    children,
    noCloseIcon = false,
    maxWidth = 'md',
    className
  } = _ref;
  const dispatch = useDispatch();
  const {
    data
  } = useSelector(state => state.modal);
  const modalData = data === null || data === void 0 ? void 0 : data.find(modal => modal.id === id);
  if (!modalData) {
    return null;
  }

  // --
  const {
    maxWidth: oMaxWidth,
    ...childProps
  } = modalData.options || {};
  const onClose = () => dispatch(closeModal(id));
  const modal = /*#__PURE__*/React.createElement(Dialog, {
    id: id,
    fullWidth: true,
    maxWidth: oMaxWidth || maxWidth,
    open: !!modalData,
    TransitionComponent: transition
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true
  }, modalData.title || title, !noCloseIcon && /*#__PURE__*/React.createElement(IconButton, {
    icon: CrossIcon,
    onClick: onClose,
    float: "right"
  })), /*#__PURE__*/React.createElement(DialogContent, {
    className: className
  }, modalData && /*#__PURE__*/cloneElement(children, childProps)));
  return modal;
};
Modal.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.any,
  variant: PropTypes.string
};
export default Modal;